/** @module csi/task/TaskDueDateGroupNodes */
define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/store/GroupNodes",
	"csi/task/util",
	"csi/types",
	"csi/xml"
], function(declare, locale, GroupNodes, TaskUtil, types, xml) {

	return declare(GroupNodes, {
		customGrouping: true,

		/**
		 * @override
		 * Return label for custom group value
		 */
		onCustomGroupLabel: function(customGroupValue) {
			return locale.resource("TaskDueDate" + customGroupValue);
		},

		/**
		 * @override
		 * Return date grouping value for given time value (in milliseconds)
		 */
		onCustomGroupValue: function(value, item) {
			const dt = (value == xml.VALUE_BLANK) ? null : types.getTimeDate(value, this.spec.format);
			return TaskUtil.getDueDateClassification(dt);
		}
	});
});